<template>
  <div id="index" ref="appBody">
    <div class="home">
      <img src="../assets/top.png" class="top" />
      <div class="middle">
        <!-- <div class="middle-img"> -->
        <img src="../assets/left3.png" class="left" />
        <!-- </div> -->
        <div class="right">
          <div class="jobOne" v-for="item in list" :key="item.id">
            <img src="../assets/backgroundLogo.png" class="banner" />
            <div class="showLogo">
              <div class="showLogo-border">
                <img :src="item.GWQRPIC" alt="" />
              </div>
              <!-- <div class="sao-qr">扫码查看详细内容</div> -->
            </div>
            <div class="showMessage">
              <div class="first">
                <div class="name">{{ item.CFA015 }}</div>
                <span class="salary">{{ item.XZFW }}</span>
              </div>
              <div class="detail">
                <!-- <img src="../assets/experience.png" alt="">
                <span>3-5年</span>
                <img src="../assets/education.png" alt="">
                <span>本科</span> -->
                <img src="../assets/person.png" alt="" />
                <span>招录{{ item.CFA024 || "0" }}人</span>
              </div>
              <div class="zhanwei" v-if="item.GWBQ.length == 0"></div>
              <div class="ability">
                <span v-for="items in item.GWBQ" :key="items.ROW_ID">
                  {{ items.CFA033 }}
                </span>
              </div>
              <div>
                <div class="company">{{ item.QYJC }}</div>
                <div class="area">
                  <span class="weizhi">{{ item.SZBK }}</span>
                  <div>{{ item.QYXZ + "·" + "规模：" + item.GSGM }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src="../assets/bottom2.png" class="bottom" />
      <div class="dialogArea" v-if="selectModule">
        <div class="showAllAreas" v-drag>
          <div class="day">{{ day }}秒后自动关闭</div>
          <div class="getTop">
            <div class="oneGet">
              <div class="oneTitle">全市区</div>
              <div class="bigChose">
                <span v-for="item in areas" :key="item.id">
                  <span
                    :class="
                      item.checked ? 'getActived smallChose' : 'smallChose'
                    "
                    v-if="item.code == ''"
                    @click="changeArea(item.code)"
                  >
                    {{ item.name }}
                  </span>
                </span>
              </div>
            </div>
            <div class="oneGet">
              <div class="oneTitle">开发区</div>
              <div class="bigChose">
                <span v-for="item in area1" :key="item.id">
                  <span
                    :class="
                      item.checked ? 'getActived smallChose' : 'smallChose'
                    "
                    @click="changeArea(item.code)"
                    v-if="item.code > 60"
                  >
                    {{ item.name }}
                  </span>
                </span>
              </div>
            </div>
            <div class="oneGet">
              <div class="oneTitle">城区</div>
              <div class="bigChose">
                <span v-for="item in area2" :key="item.id">
                  <span
                    :class="
                      item.checked ? 'getActived smallChose' : 'smallChose'
                    "
                    @click="changeArea(item.code)"
                    v-if="item.code < 60 && item.code > 40"
                  >
                    {{ item.name }}
                  </span>
                </span>
              </div>
            </div>
            <div class="oneGet">
              <div class="oneTitle">乡镇(街道)</div>
              <div class="bigChose">
                <span v-for="item in area3" :key="item.id">
                  <span
                    :class="
                      item.checked ? 'getActived smallChose' : 'smallChose'
                    "
                    @click="changeArea(item.code)"
                    v-if="item.code < 40 && item.code != ''"
                  >
                    {{ item.name }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="sure" @click="getSure">确认选择</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import drawMixin from "../utils/drawMixin1";
  import { postRequest } from "@/api/index";
  export default {
    mixins: [drawMixin],
    name: "HomeView",
    data() {
      return {
        selectModule: true,
        list: [],
        paramQuery: {
          currentPage: 1,
          pageSize: 4,
        },
        tableTimer: null,
        timer: null,
        day: 15,
        total: 0,
        arr: [],
        areas: [{ name: "全市区", code: "", checked: false }],
        area1: [
          { name: "经开区", code: "71", checked: false },
          { name: "高新区", code: "65", checked: false },
        ],
        area2: [
          { name: "虞山街道", code: "55", checked: false },
          { name: "常福街道", code: "56", checked: false },
          { name: "莫城街道", code: "57", checked: false },
          { name: "琴川街道", code: "58", checked: false },
        ],
        area3: [
          { name: "海虞镇", code: "38", checked: false },
          { name: "梅李镇", code: "36", checked: false },
          { name: "辛庄镇", code: "31", checked: false },
          { name: "古里镇", code: "17", checked: false },
          { name: "支塘镇", code: "18", checked: false },
          { name: "沙家浜镇", code: "16", checked: false },
          { name: "董浜镇", code: "19", checked: false },
          { name: "尚湖镇", code: "23", checked: false },
          { name: "碧溪街道", code: "37", checked: false },
        ],
        areaActive: "",
        arrArea: [],
        getOtherParam: {
          currentPage: 1,
          pageSize: 999999,
        },
      };
    },
    directives: {
      drag(el) {
        let oDiv = el; // 当前元素
        // let self = this // 上下文
        // 禁止选择网页上的文字
        document.onselectstart = function () {
          return false;
        };
        oDiv.onmousedown = function (e) {
          // 鼠标按下，计算当前元素距离可视区的距离
          let disX = e.clientX - oDiv.offsetLeft;
          let disY = e.clientY;
          document.onmousemove = function (e) {
            // 通过事件委托，计算移动的距离
            let l = e.clientX - disX;
            let t = e.clientY - disY;
            // 移动当前元素
            oDiv.style.left = l + "px";
            oDiv.style.top = t + "px";
          };
          document.onmouseup = function (e) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
          // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
          return false;
        };
      },
    },
    mounted() {
      // 获取传入的参数
      var param = this.$route.query;
      if (param.area == "all") {
        this.getSure();
      } else {
        this.dayTime();
      }
    },
    created() {
      //  this.selectByPage()
      //  this.getAllTotal()
    },
    beforeDestroy() {
      clearInterval(this.tableTimer);
      clearInterval(this.timer);
    },
    methods: {
      dayTime() {
        // 启动计时器，每秒更新day值
        this.timer = setInterval(() => {
          if (this.day > 0) {
            this.day--;
          } else {
            // clearInterval(this.timer); // 倒计时结束，停止计时器
            this.getSure();
          }
        }, 1000);
      },
      changeArea(code) {
        var self = this;
        this.areas.map((res, count) => {
          if (res.code == code) {
            res.checked = !res.checked;
          }
        });
        this.area1.map((res, count) => {
          if (res.code == code) {
            res.checked = !res.checked;
          }
        });
        this.area2.map((res, count) => {
          if (res.code == code) {
            res.checked = !res.checked;
          }
        });
        this.area3.map((res, count) => {
          if (res.code == code) {
            res.checked = !res.checked;
          }
        });
        var areaActive = this.areaActive;
        if (areaActive.indexOf(code) != -1) {
          self.arrArea.splice(self.arrArea.indexOf(code), 1);
          self.areaActive = self.arrArea.join(",");
        } else {
          this.arrArea.push(code);
          this.areaActive = self.arrArea.join(",");
        }
      },
      getSure() {
        this.selectModule = false;
        clearInterval(this.timer);
        this.day = 15;

        this.paramQuery.jd = this.areaActive;
        this.getOtherParam.jd = this.areaActive;
        this.getAllTotal();
        this.selectByPage();
      },
      getAllTotal() {
        postRequest("/H5/recruitAllPost", this.getOtherParam).then((res) => {
          this.total = res.data.record.data.length;
        });
      },
      getList() {
        var self = this;
        postRequest("/H5/recruitAllPost", this.paramQuery).then((res) => {
          this.list = res.data.record.data;
          this.list.map((res) => {
            self.arr.push(res);
          });
        });
      },
      selectByPage() {
        var self = this;
        this.paramQuery.currentPage = 1;
        this.getList();
        this.tableTimer = setInterval(() => {
          if (self.arr.length >= self.total) {
            self.arr = [];
            self.paramQuery.currentPage = 1;
            self.getList();
          } else {
            self.paramQuery.currentPage++;
            self.getList();
          }
        }, 10000);
      },
    },
  };
</script>
<style lang="scss" scoped>
  #index {
    color: #f8f8f8;
    width: 1920px;
    height: 1080px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: left top;
    overflow: hidden;
  }
  .home-top {
    width: 100%;
    height: 100px;
    overflow: hidden; //img如果超出这个div会隐藏超出部分
    display: flex; //flex布局
    align-items: center; //让img放在div的中间，居中
    background-color: #f5f4f0;
  }
  .top {
    width: 100%;
    height: 100px;
    // height: 100px;
    // object-fit: cover;
  }
  .bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 50px;
  }
  .middle {
    position: absolute;
    top: 100px;
    bottom: 50px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    // margin-top: -20px;
  }
  .middle-left {
    // width: 65%;
    // height: 610px;
    // overflow: hidden;//img如果超出这个div会隐藏超出部分
    // display: flex;//flex布局
    // align-items: center;//让img放在div的中间，居中
    // background-color: #f5f4f0;
  }
  // .middle-img {
  //   width: 692px;
  //   height: 648px;
  //   background-image: url('../assets/left4.png');
  // }
  .left {
    width: 1140px;
    height: 930px;
    // margin-top: 50px;
    //   height: ;
    // height: 100%;
    //   object-fit: contain;
  }
  .right {
    background: #f5f4f0;
    flex: 1;
    //   height: 497px;
    padding: 0px 0px 0 10px;
    box-sizing: border-box;
    //   overflow: hidden;
    transition: all 0.5s;
    margin-right: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .jobOne {
    border-radius: 10px;
    background: #fff;
    width: 100%;
    position: relative;
    // margin-bottom: 10px;
    padding: 5px 10px;
    box-sizing: border-box;
    display: flex;
  }
  .banner {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    //   object-fit: contain;
    width: 128px;
    height: 128px;
  }
  .showLogo {
    display: inline-block;
    vertical-align: middle;
    width: 200px;
    .showLogo-border {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      // csss实现四角边框
      // border-image-source: radial-gradient(65% 65%, transparent 0px, transparent 100%, #666666 100%);
      // border-image-slice: 1;
      // border-width: 1px;
      // border-style: solid;
      // border-image-outset: 1cm;
    }
    //   margin-left: 20px;
    img {
      width: 200px;
      height: 200px;
      display: block;
      margin: 0 auto;
      // margin-bottom: 14px;
    }
    .sao-qr {
      color: #999999;
      font-size: 10px;
      text-align: center;
      transform: scale(0.7);
      // margin-top: 12px;
    }
  }
  .showMessage {
    vertical-align: middle;
    display: inline-block;
    padding: 10px 0;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    //   margin-left: 20px;
    //   width: 70%;
    margin-left: 10px;
    .first {
      margin-bottom: 3px;
      display: flex;
      justify-content: space-between;
      .salary {
        color: #2e6ead;
        font-size: 24px;
        font-weight: bold;
        float: right;
      }
      .name {
        font-size: 24px;
        color: #231814;
        font-weight: bold;
      }
    }
    .detail {
      img {
        width: 30px;
        height: 30px;
        vertical-align: middle;
      }
      span {
        color: #231814;
        font-size: 20px;
        display: inline-block;
        vertical-align: middle;
        margin: 0 20px 0 5px;
      }
    }
    .zhanwei {
      width: 100%;
      height: 25px;
    }
    .ability {
      span {
        background: #e5f2ff;
        border-radius: 8px;
        color: #2e6ead;
        font-size: 16px;
        font-weight: 400;
        padding: 6px 8px;
        display: inline-block;
        margin: 3px 10px 3px 0;
      }
    }
    .company {
      color: #231814;
      font-size: 18px;
      font-weight: 400;
      margin-bottom: 3px;
    }
    .area {
      margin-top: 5px;
      .weizhi {
        color: #231814;
        font-size: 20px;
        font-weight: 400;
        float: right;
      }
      div {
        color: #231814;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  .dialogArea {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba($color: #000000, $alpha: 0.3);
    .showAllAreas {
      background: #fff;
      width: 55%;
      // overflow: hidden;
      // height: 70vh;
      border-radius: 30px;
      margin: 10vh auto;
      padding: 3%;
      position: fixed;
      left: 23%;
    }
    .day {
      color: #333;
      position: absolute;
      right: 30px;
      top: 30px;
    }
    .moduleName {
      text-align: center;
      font-size: 40px;
      margin-bottom: 30px;
    }
    .single {
      padding: 20px;
      font-size: 32px;
    }
    .single:hover {
      background: #e2e2e2;
      border-radius: 20px;
    }
  }
  .allModules {
    width: 50%;
    display: inline-block;
    vertical-align: top;
  }

  .oneGet {
    margin-bottom: 5px;
  }
  .oneTitle {
    color: #999999;
    font-size: 17px;
    margin-bottom: 10px;
  }
  .bigChose {
    display: flex;
    flex-wrap: wrap;
  }
  .bigChose > span {
    width: 30%;
    margin-right: 3%;
  }
  .smallChose {
    display: inline-block;
    width: 100%;
    height: 5vh;
    line-height: 5vh;
    text-align: center;
    color: #333333;
    background-color: #f8f8f8;
    border-radius: 5px;
    margin-right: 20px;
    margin-bottom: 12px;
  }
  .getActived {
    background-color: #306ead !important;
    color: #fff !important;
  }
  .activeTitle {
    color: #306ead !important;
  }
  .bottomButtons {
    margin-top: 10px;
    text-align: center;
  }
  .sure {
    background-color: #306ead;
    color: #fff;
    text-align: center;
    width: 12vw;
    height: 6vh;
    line-height: 6vh;
    border-radius: 20px;
    font-size: 20px;
    float: right;
    cursor: pointer;
  }
</style>
